import React from 'react';
import { Step1Info } from './components/Step1Info';
import { Step2Establishment } from './components/Step2Establishment';
import { Step3Rncp } from './components/Step3Rncp';
import { Step4Declaration } from './components/Step4Declaration';
import './vertical-stepper.css';

export const VerticalStepper = () => {
  return (
    <div className={'flex flex-col gap-6 m-2 relative pl-10 left-line'}>

      <Step1Info />

      <Step2Establishment />

      <Step3Rncp />

      <Step4Declaration />
    </div>
  );
};